import React from 'react';
import logo from '../images/evrfy_logo.svg'

import {
  Container, Row, Col, Form, Input, Button, Navbar, Nav,
  NavbarBrand, NavLink, NavItem, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';


const Header = () => (
  <header>

    <div className="header-mobile">
      <div className="mobile-app-logo"><a href="/"><img  src={logo} /></a></div>
    </div>

    <Navbar color="light" light expand="xs" className="border-bottom border-gray bg-white" style={{ height: 100 }}>
    
      <Container>
        <Row className="position-relative w-100 align-items-center">
        
          <Col className="d-none d-lg-flex justify-content-start">

            <div className="logo-top">
              <a href="/"><img src={logo} /></a>
            </div>
            <div className="vrfy-header-sub">Court Document Authentication<br/>and Verification System</div>
              
          </Col>


          
          <Col className="d-none d-lg-flex justify-content-end">
            <Nav className="vrfy-top-nav" navbar>
              
              <NavItem className="d-flex align-items-center">
                <NavLink className="font-weight-bold" href="/about">About</NavLink>
              </NavItem>
              {/*}
              <NavItem className="d-flex align-items-center">
                <NavLink className="font-weight-bold" href="/faqs">FAQs</NavLink>
              </NavItem>
              */}

              <NavItem className="d-flex align-items-center">
                <NavLink className="font-weight-bold" href="/help">Help</NavLink>
              </NavItem>
            </Nav>
          </Col>

          
        </Row>
      </Container>
      
    </Navbar>
  </header>
);

export default Header;